
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[lang]/syndicateOverview",
      function () {
        return require("private-next-pages/[lang]/syndicateOverview.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[lang]/syndicateOverview"])
      });
    }
  